import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, componentId, mobileIs } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
const HeroImage = props => {
    const { rendering, fields, page } = props;
    const {
        pc_title, m_title, pc_image, m_image
    } = fields;
    const isMobile = mobileIs()

    const rootClasses = classNames("c-hero-image", getOverallSettingsClasses(fields));
    const rootId = componentId(rendering);
    return (
        <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
            <div className="c-hero-image__text" >
                {!isMobile && <RichText tag="div" className="c-hero-image__title" field={pc_title} />}
                {isMobile && <RichText tag="div" className="c-hero-image__title" field={m_title} />}
            </div>

            <div className="c-hero-image__background">
                {!isMobile && <BackgroundImage {...pc_image} className="c-hero-image__bg-image" />}
                {isMobile && <BackgroundImage {...m_image} className="c-hero-image__bg-image" />}
            </div>
        </div>
    );
};

export default HeroImage;